import { memo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormRow, ConditionalRender } from '@ui';
import { ControlledYesNoRadio } from '@lp/features/admin/forms/components/inputs/ControlledYesNoRadio';
import { NewTXCenterForm } from '../types';

export const TXCenterFixedPriceContract = memo(() => {
  const { control } = useFormContext<NewTXCenterForm>();
  const hasFixedPriceContract = useWatch({ control, name: 'hasFixedPriceContract' });

  return (
    <ConditionalRender show={hasFixedPriceContract}>
      <AdminFormRow title="Fixed-Price Contract" isRequired>
        <ControlledYesNoRadio name="hasFixedPriceContract" isReadOnly />
      </AdminFormRow>
    </ConditionalRender>
  );
});
